import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import { Prompt } from "react-router";
import { Link } from "react-router-dom";
import { userFarmDetail } from "../../../config/farmDetails";
import { harvestYearDetail } from "../../../config/harvestYearDetail";
import Button from "../../FormElement/Button";
import { validForm } from "../../FormElement/FormValidator";
import InputFiled from "../../FormElement/InputFiled";
import Dropdown from "../../FormElement/Dropdown";
import { bindActionCreators } from "redux";
import {
  commodityList,
  getCommodityVariertyList,
} from "../../../modules/contract/action";
import { connect } from "react-redux";

const destTypes = ["", "internal", "external"];

const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};

class DestinationForm extends Component {
  handleVarietyonEdit = false;
  constructor(props) {
    super(props);
    const { destInfo, type } = props;
    this.state = {
      destInfo: {
        farmId: userFarmDetail().id || props.MainFarmId,
        type: destInfo
          ? destInfo.destinationTypeDTO
            ? destInfo.destinationTypeDTO.id
            : type
          : type,
        name: destInfo ? destInfo.name : null,
        code: destInfo ? destInfo.code : null,
        distance: destInfo ? destInfo.distance : null,
        loadCostPerBushel: destInfo ? destInfo.loadCostPerBushel : null,
        harvestYear: harvestYearDetail().name,
        commodityId: destInfo ? destInfo.commodity?destInfo.commodity.commodityId:null : null,
        commodityVarietyId: destInfo ? destInfo.commodityVariety?destInfo.commodityVariety.varietyId:null : null,
      },
      formErrors: {
        type: "",
        name: "",
        code: ""
      },
      isInvalid: true,
      edited: false,
      commodityVarietyListOption: [],
    };
  }
  componentDidMount() {
    const harvestYearId = harvestYearDetail().name;
    this.props.actions.getCommodityVariertyList(harvestYearId).then(() => {
      this.props.actions.commodityList();
      if (this.state.destInfo) {
        this.getVariertyList(this.state.destInfo.commodityId);
      }
    });
  }
  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "name") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "distance" || name === "loadCostPerBushel") {
      if (value.match(/^\d{0,10}(\.\d{0,2})?$/)) {
        this.updateState(name, value);
      }
    } else if (name === "code") {
      if (value.match(/^(\w|\ |\-){0,51}$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
    switch (name) {
      case "commodityId":
        this.getVariertyList(value);
        break;
      default:
        break;
    };
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          destInfo: {
            ...prevState.destInfo,
            [name]: value
          }
        };
      },
      () => {
        const { destInfo } = this.state;
        const requiredFields = { ...destInfo };

        delete requiredFields.distance;
        delete requiredFields.loadCostPerBushel;
        delete requiredFields.commodityId;
        delete requiredFields.commodityVarietyId;

        this.setState({
          isInvalid: validForm(this.state.formErrors, requiredFields)
        });
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { destInfo } = this.state;
        const requiredFields = { ...destInfo };

        delete requiredFields.distance;
        delete requiredFields.loadCostPerBushel;
        delete requiredFields.commodityId;
        delete requiredFields.commodityVarietyId;

        this.setState({
          isInvalid: validForm(this.state.formErrors, requiredFields)
        });
      }
    );
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ isInvalid: true, edited: false });
    const { destInfo } = this.state;
    const formData = { ...destInfo };
    formData.type = destTypes[formData.type];
    formData.farmId = userFarmDetail().id || this.props.MainFarmId;
    formData.harvestYear = harvestYearDetail().name;
    formData.defaultCommodityId = formData.commodityId
    formData.defaultVarietyId =  formData.commodityVarietyId;
    this.props.handleSubmit(formData);
  };
  getfilterCommodityList = commodityVarietyList => {
    let comm = commodityVarietyList !== undefined ? commodityVarietyList : {};

    let commarray = [];
    commarray = Object.keys(comm).map(value => {
      return {
        id: comm[value].commodityResponseDTO.id,
        name: comm[value].commodityResponseDTO.name
      };
    });
    const filteredArr = commarray.reduce((acc, current) => {
      const x = acc.find(item => item.id === current.id);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return filteredArr;
  };

  getVariertyList = (id, VarietyId) => {
    let mode = this.props.editMode;
    let selectedVariety = this.state.destInfo
      ? this.state.destInfo.commodityVarietyId
      : "";
    const { commodityVarietyList } = this.props;
    let option = commodityVarietyList.filter(
      value => value.commodityResponseDTO.id === id
    );
   var optionindex
    var i;
    for (i = 0; i < option.length; i++) {
      if(option[i].name==="General")
      {
         optionindex=option[i].id
      }
    }
   
    this.setState(prevState => {
      return {
        ...prevState,
        commodityVarietyListOption: option,
        destInfo: {
          ...prevState.destInfo,
          commodityVarietyId:
            mode && !this.handleVarietyonEdit
              ? selectedVariety
              : VarietyId
              ? VarietyId
              // : option[0].id
              :optionindex
        }
      };
     
    }, 
    this.getEstimatedHomeScaleShrinkBushels());
    this.handleVarietyonEdit = true;
  };

  getEstimatedHomeScaleShrinkBushels = () => {
    //this.getcommidityLoadBushlesValue();
    const { destInfo, commodityVarietyLbsPerBushel } = this.state;

    if (
      destInfo.homeScaleWeightFilled &&
      destInfo.homeScaleWeightEmpty &&
      commodityVarietyLbsPerBushel
    ) {
      let calHomeScaleShrinkBushels = (
        ((destInfo.homeScaleWeightFilled - destInfo.homeScaleWeightEmpty) /
          commodityVarietyLbsPerBushel) *
          destInfo.shrinkMultiplier || 0
      ).toFixed(4);

      this.setState({
        destInfo: {
          ...this.state.destInfo,
          estimatedHomeScaleShrinkBushels: Number(calHomeScaleShrinkBushels)
        }
      });
    }
  };
  render() {
    const { destInfo, isInvalid, edited,commodityVarietyListOption } = this.state;
    const { editMode = false, formLabel, buttonLabel } = this.props;
    return (
      <div className="">
        <Prompt when={edited} message="Changes you made may not be saved." />
        <div className="textRequired">* Required Cells</div>
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container spacing={16}>
            <Grid item xs={12}>
              <InputFiled
                value={destInfo.name}
                label="Name"
                type="text"
                required
                name="name"
                validations={["required", "maxSize"]}
                handleChange={this.handleChange}
                handleError={this.handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={destInfo.code}
                label="Acronym"
                type="text"
                required
                name="code"
                validations={["required", "maxSize"]}
                handleChange={this.handleChange}
                handleError={this.handleError}
              />
            </Grid>
            {(this.props.type=== 1 ||(this.props.editMode==true && this.props.destInfo.type=== "Internal")) && (
              <Grid item xs={6}>
              <Dropdown
                value={destInfo.commodityId}
                label="Default Commodity"
                type="text"
                name="commodityId"
                //fieldError={formErrors.commodityId}
                options={this.getfilterCommodityList(
                  this.props.commodityVarietyList
                )}
                validations={["required"]}
                handleChange={this.handleChange}
                handleError={this.handleError}
              />
            </Grid>
            )}
            {(this.props.type=== 1 ||(this.props.editMode==true && this.props.destInfo.type=== "Internal")) && (
              <Grid item xs={6}>
                <Dropdown
                required={
                  commodityVarietyListOption.length > 0 ? true : false
                }
                  value={destInfo.commodityVarietyId}
                  label="Default Variety"
                  type="text"
                  name="commodityVarietyId"
                  validations={["required"]}
                  options={commodityVarietyListOption}
                  handleChange={this.handleChange}
                  //fieldError={formErrors.commodityVarietyId}
                  handleError={this.handleError}
                  disabled={
                    commodityVarietyListOption.length > 0 ? false : true
                  }
                />
              </Grid>  
            )}
              
            <Grid item xs={12}>
              <InputFiled
                value={destInfo.distance}
                label="Distance (miles)"
                type="text"
                name="distance"
                validations={["onlyNumber"]}
                handleChange={this.handleChange}
                handleError={this.handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={destInfo.loadCostPerBushel}
                label="Estimated Load Cost per Bushel ($)"
                type="text"
                name="loadCostPerBushel"
                validations={["onlyNumber"]}
                handleChange={this.handleChange}
                handleError={this.handleError}
              />
            </Grid>
          </Grid>
          <div className="signInSection" style={signInSectionStyle}>
            <Link
              to={`/farmsetup/destinations/${destTypes[destInfo.type]}`}
              style={{ color: "blue" }}
            >
              Cancel
            </Link>
            <Button
              name={buttonLabel}
              disabled={isInvalid}
              onclick={this.handleSubmit}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    commodityList: state.contractReducer.commodityList,
    commodityVarietyList: state.contractReducer.commodityVarietyList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        commodityList,
        getCommodityVariertyList,
      },
      dispatch
    )
  };
}

export default //DestinationForm;
 connect(
  mapStateToProps,
  mapDispatchToProps
) (DestinationForm);



// WEBPACK FOOTER //
// ./src/components/private/Destinations/DestinationForm.js